"use client";

import { Body, Box } from "@biom3/react";

export const UnsubscribeFooter = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Body
        size="small"
        sx={{
          color: "base.color.text.body.secondary",
          textAlign: "center",
        }}
        testId="gems-footer_text"
      >
        Unsubscribe at any time by following the instructions in our emails
      </Body>
    </Box>
  );
};
